export const SPECIALTIES_ICONS_MAP = {
  SCL: 'vision-therapy',
  DYT: 'dry-eye',
  MC: 'myopia',
  VT: 'contact-lens',
  GME: 'ophthalmology',
  APL: 'correction-eye',
  DEFAULT: 'default-eye',
};
